import { motion } from "framer-motion";

const modalInitial = { opacity: 0, scale: 0.95 };
const modalAnimate = { opacity: 1, scale: 1 };

export const ProjectModal = ({ project, onClose }) => {
  if (!project) return null;
  const isMP4 = project.video_type === "mp4";
  const isImageOnly = project.video_type === "image" || !project.video_url;
  const isPortrait = project.aspect_ratio === "9:16";
  const isSquare = project.aspect_ratio === "1:1";
  const modalWidth = isPortrait ? "max-w-md" : isSquare ? "max-w-2xl" : "max-w-5xl";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={onClose} data-testid="project-modal">
      <motion.div initial={modalInitial} animate={modalAnimate} className={`w-full ${modalWidth} bg-[#1C1C1C] rounded-2xl overflow-hidden max-h-[90vh] overflow-y-auto`} onClick={(e) => e.stopPropagation()}>
        {project.video_url && !isImageOnly ? (
          isMP4 ? (
            <div className={`bg-black ${isPortrait ? "aspect-[9/16] max-h-[60vh] mx-auto" : isSquare ? "aspect-square" : "aspect-video"}`}>
              <video src={project.video_url} controls autoPlay playsInline className="w-full h-full object-contain" />
            </div>
          ) : (
            <div className="video-wrapper rounded-none">
              <iframe src={`https://player.vimeo.com/video/${project.video_url.split('/').pop().split('?')[0]}?autoplay=1&title=0&byline=0&portrait=0`} allow="autoplay; fullscreen" allowFullScreen title={project.title} />
            </div>
          )
        ) : (
          <img src={project.thumbnail} alt={project.title} className={`w-full object-contain bg-[#0A0A0A] ${isPortrait ? "max-h-[65vh]" : "max-h-[70vh]"}`} />
        )}
        <div className="p-8">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
            <div>
              <span className="inline-block text-xs font-semibold uppercase tracking-[0.15em] text-[#FF5E3A] mb-2">{project.category}</span>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">{project.title}</h2>
              <p className="text-white/40">{project.client} • {project.year}</p>
            </div>
            <button onClick={onClose} className="text-white/50 hover:text-white font-semibold text-sm px-4 py-2 rounded-full border border-white/20 hover:border-white/50 transition-colors" data-testid="modal-close-btn">Close</button>
          </div>
          <p className="text-white/50 mt-6 leading-relaxed">{project.description}</p>
        </div>
      </motion.div>
    </div>
  );
};
